import { renderBinaryRadioButtonGroup, } from './renderBinaryRadioButtonGroup.js';
export const renderPaymentType = (props) => renderBinaryRadioButtonGroup({
    ...props,
    className: 'sm:flex-col',
    items: [
        { id: 'annuity', text: 'Аннуитетный' },
        { id: 'differential', text: 'Дифференцированный' },
    ],
});
//# sourceMappingURL=renderPaymentType.js.map